import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudStorageQuota = (projectId, params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}storage_quota/${projectId}/`,
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const updatePrivateCloudStorageQuota = (data, projectId) => {
  return axios.request({
    url: `${privateCloudBaseUrl}storage_quota/${projectId}/`,
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'put'
  })
}
